import { FC } from 'react';
import { Label, TableRow } from '../../atoms';
import { SortableTable } from '../../molecules';
import { EventLogMessageResponse } from '../../../store/contextAPI/eventLogging/dto/response/event-log-message-response';

export interface UserManagementEventLoggingTemplateProps {
  data: EventLogMessageResponse;
}

const UserManagementEventLoggingTemplate: FC<
  UserManagementEventLoggingTemplateProps
> = ({ data }) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}.${month}.${year} ${hours}:${minutes}`;
  };

  return (
    <SortableTable
      data={data.items || []}
      columns={[
        { label: 'User', key: 'userName' },
        { label: 'Event Action', key: 'eventLogAction' },
        { label: 'API', key: 'producingApi' },
        { label: 'Entity Name', key: 'entityName' },
        { label: 'Entity Id', key: 'entityId' },
        { label: 'Date & Time', key: 'createdOnDateTimeUtc' },
      ]}
      renderRow={(row) => (
        <TableRow key={row.id}>
          <Label content={row.userName ?? ''}></Label>
          <Label content={row.eventLogAction ?? ''}></Label>
          <Label content={row.entity ?? ''}></Label>
          <Label content={row.entityName ?? ''}></Label>
          <Label content={row.entityId ?? ''}></Label>
          <Label content={formatDate(row.createdOnDateTimeUtc ?? '')}></Label>
        </TableRow>
      )}
      showEditButtonHeader={false}
      showDeleteButtonHeader={false}
    />
  );
};

export default UserManagementEventLoggingTemplate;
